export enum OrderTypeEnum {
  Orders = 'Orders',
  Quotations = 'Quotations',
}
